

export function getXeroStatusTitle (xero) {
  if(xero) {
    switch (xero.status) {
      case 'success': return 'Xero Synchronised'
      case 'pending': return 'Xero Synchronzation is processing'
      default : return 'Xero Synchronization failed: ' + xero.message
    }
  }

  return 'Your data is not synced to Xero yet.'
}
